import type { PanelComponentSpec } from '@src/types/LayoutConfig';
import { CustomerBalancesPanel } from './blotters/CustomerBalancesPanel';
import { CustomerOrdersPanel } from './blotters/CustomerOrdersPanel';
import { CustomerTradesPanel } from './blotters/CustomerTradesPanel';
import { CustomerTransfersPanel } from './blotters/CustomerTransfersPanel';
import { PANEL_COMPONENT_GROUPS } from './groups';

export const CUSTOMER_PANEL_COMPONENTS: PanelComponentSpec[] = [
  {
    group: PANEL_COMPONENT_GROUPS['dealer'],
    section: 'trading',
    type: 'customerOrdersBlotter',
    label: 'Customer Orders',
    icon: undefined,
    canBeAdded: true,
    renderer: CustomerOrdersPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['dealer'],
    section: 'trading',
    type: 'customerTradesBlotter',
    label: 'Customer Trades',
    icon: undefined,
    canBeAdded: true,
    renderer: CustomerTradesPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['dealer'],
    section: 'trading',
    type: 'customerBalancesBlotter',
    label: 'Customer Balances',
    icon: undefined,
    canBeAdded: true,
    renderer: CustomerBalancesPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['dealer'],
    section: 'trading',
    type: 'customerTransfersBlotter',
    label: 'Customer Transfers',
    icon: undefined,
    canBeAdded: true,
    renderer: CustomerTransfersPanel,
  },
];
